import { render, staticRenderFns } from "./IconNote.vue?vue&type=template&id=1ace4860&scoped=true&"
import script from "./IconNote.vue?vue&type=script&lang=js&"
export * from "./IconNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ace4860",
  null
  
)

export default component.exports